import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoon, faSunBright } from '@fortawesome/pro-solid-svg-icons';
import { Tooltip, TooltipTrigger, TooltipContent } from '../../Tooltip';

export function LightsMenu({ lights, activeLight, onSelectLight }) {

  return (
    <Tooltip>
      <TooltipTrigger>
        <div
          className="vr-menu-button"
          onClick={() => {
            onSelectLight(lights.find((l) => l !== activeLight));
          }}
        >
          <FontAwesomeIcon
            icon={activeLight === 'Day' ? faMoon : faSunBright}
            transform={{ rotate: -20 }}
            className="fa-xl"
          />
        </div>
      </TooltipTrigger>
      <TooltipContent>
        {activeLight === 'Day' ? 'Night view' : 'Day view'}
      </TooltipContent>
    </Tooltip>
  );
}
